import { Stack } from "@mui/material";
import { useFollowRequestsQuery } from "Api/Queries/Social/useFollowRequestsQuery";
import { PaperTitle } from "Components/Shared/PaperTitle";
import { PrimaryPaper } from "Components/Shared/PrimaryPaper";
import { FollowRequestDirection } from "Infrastructure/Api/Api";
import { IncomingFollowRequestsList } from "Pages/People/IncomingFollowRequestsList";
import { OutgoingFollowRequestsList } from "Pages/People/OutgoingFollowRequestsList";
import { Resources, useResource } from "Translations/Resources";

const RESOURCES = Resources.Social.People;

/**
 * Pending follow requests, both directions, under one title. Rendered only when there is
 * something pending — an empty inbox needs no section. Each direction's list owns its own
 * actions: incoming (approve/delete, IncomingFollowRequestsList) and outgoing (withdraw,
 * OutgoingFollowRequestsList).
 */
export const FollowRequestsSection = () => {
  const { t } = useResource();
  const { data: incoming } = useFollowRequestsQuery(
    FollowRequestDirection.Incoming,
  );
  const { data: outgoing } = useFollowRequestsQuery(
    FollowRequestDirection.Outgoing,
  );

  if (!incoming?.length && !outgoing?.length) {
    return null;
  }

  return (
    <PrimaryPaper>
      <Stack gap={3}>
        <PaperTitle p={0}>{t(RESOURCES.RequestsTitle)}</PaperTitle>
        {!!incoming?.length && (
          <IncomingFollowRequestsList requests={incoming} />
        )}
        {!!outgoing?.length && (
          <OutgoingFollowRequestsList requests={outgoing} />
        )}
      </Stack>
    </PrimaryPaper>
  );
};
